import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";

const ESPChart = () => {
  const [state] = useState({
    series: [70], // percentage
    options: {
      chart: {
        type: "radialBar",
        height: 200,
      },
      plotOptions: {
        radialBar: {
          hollow: {
            size: "70%",
          },
          dataLabels: {
            name: {
              show: false, 
            },
            value: {
              show: true,
              fontSize: "28px",
              fontWeight: "bold",
              color: "#7398C3",
              formatter: (val) => `${val}%`, 
            },
          },
        },
      },
      colors: ["#7398C3"],
    },
  });

  return (
    <div className="">
      <ReactApexChart
        options={state.options}
        series={state.series}
        type="radialBar"
        height={200}
      />
    </div>
  );
};

export default ESPChart;
